onLoad(($) => {
  const nodesPassive = $('.JS-invested-funds-passive');
  const nodesAccountPassive = $('.JS-account-passive');
  var settlement_type = $('input[name="ticket_quotum[settlement_type]"]:checked').val();

  const selectedOperationType = () => (
    $('input[name="ticket_passive_quotum[operation_type]"]:checked').val()
  );

  const operationTypeForFundSearch = (element) => {
    const section = element?.closest('.JS-passive-secondary-market-fields, .JS-passive-standard-fields');
    if (section?.classList.contains('JS-passive-secondary-market-fields')) {
      const hiddenType = section.querySelector('#ticket_passive_quotum_operation_type_secondary');
      if (hiddenType?.value) return hiddenType.value;
    }

    const checked = section?.querySelector('input[name="ticket_passive_quotum[operation_type]"]:checked');

    return checked?.value || selectedOperationType();
  };

  const selectedSettlementType = () => (
    $('input[name="ticket_passive_quotum[settlement_type]"]:checked').val()
  );

  const selectedShareholderDocument = () => (
    $('input[name="ticket_passive_quotum[shareholder_document_number]"]').val()
  );

  const shareholderDocumentForFundSearch = (element) => {
    const field = element?.dataset?.shareholderDocumentField;
    if (field) return ($(field).val() || '').toString();

    return selectedShareholderDocument();
  };

  const fundSelectEditable = (element) => {
    const editable = element?.dataset?.editable;
    if (editable === 'false' || editable === false) return false;
    if (editable === 'true' || editable === true) return true;

    return !element.disabled;
  };

  const selectedPassiveModality = () => (
    $('input[name="ticket_passive_quotum[modality]"]:checked').val() || 'management'
  );

  const fieldColumnWrapper = (field) => (
    field?.closest('.col-md-2, .col-md-3, .col-md-4, .col-md-6') || field?.parentElement?.parentElement
  );

  const setWrapperVisible = (wrapper, visible) => {
    if (wrapper) wrapper.style.display = visible ? '' : 'none';
  };

  // Oculta/mostra campos CETIP vs TED/TEF (passivo quotum)
  const setupPassiveBankAccountToggle = (formPrefix) => {
    const operationTypeSelector = `input[name="ticket_${formPrefix}[operation_type]"]`;
    const settlementTypeSelector = `input[name="ticket_${formPrefix}[settlement_type]"]`;
    const operationTypeRadios = document.querySelectorAll(operationTypeSelector);

    if (!operationTypeRadios.length) return;

    const settlementTypeRadios = document.querySelectorAll(settlementTypeSelector);
    const bankAccountSelect = document.getElementById(`ticket_${formPrefix}_counter_part_attributes_bank_account_id`);
    const accountCetipInput = document.getElementById(`ticket_${formPrefix}_counter_part_attributes_cetip_account`);
    const counterPartDocumentInput = document.getElementById(`ticket_${formPrefix}_counter_part_attributes_document_number`);
    const counterPartNameInput = document.getElementById(`ticket_${formPrefix}_counter_part_attributes_name`);
    const operationValue = document.getElementById(`ticket_${formPrefix}_formatted_operation_value`);

    const bankAccountWrapper = () => fieldColumnWrapper(bankAccountSelect);
    const cetipAccountWrapper = () => fieldColumnWrapper(accountCetipInput);
    const counterPartDocumentWrapper = () => fieldColumnWrapper(counterPartDocumentInput);
    const counterPartNameWrapper = () => fieldColumnWrapper(counterPartNameInput);

    const txtDangerAccount = () => (
      bankAccountWrapper()?.closest('.row')?.querySelector('.text-danger-account')
    );

    const operationValueWrapper = () => operationValue?.parentElement;

    let previousSettlementType = document.querySelector(`${settlementTypeSelector}:checked`)?.value;

    const togglePassiveSettlementFields = () => {
      const selectedOperationTypeEl = document.querySelector(`${operationTypeSelector}:checked`);
      const selectedSettlementTypeEl = document.querySelector(`${settlementTypeSelector}:checked`);

      if (!selectedOperationTypeEl || !selectedSettlementTypeEl) return;

      const selectedOperationType = selectedOperationTypeEl.value;
      const selectedSettlementType = selectedSettlementTypeEl.value;
      const dangerAccount = txtDangerAccount();
      const operationValueParent = operationValueWrapper();
      const isCetip = selectedSettlementType === 'cetip';
      const isRedeem = selectedOperationType === 'redeem' || selectedOperationType === 'full_redeem';
      const showBankAccount = selectedSettlementType === 'ted_tef' && isRedeem;

      setWrapperVisible(cetipAccountWrapper(), isCetip);
      setWrapperVisible(counterPartDocumentWrapper(), isCetip);
      setWrapperVisible(counterPartNameWrapper(), isCetip);
      setWrapperVisible(bankAccountWrapper(), showBankAccount);

      if (dangerAccount) {
        dangerAccount.style.display = showBankAccount ? 'block' : 'none';
      }

      if (operationValueParent) {
        if (selectedOperationType === 'full_redeem') {
          operationValueParent.style.display = 'none';
        } else {
          operationValueParent.style.display = 'block';
        }
      }

      if (previousSettlementType && previousSettlementType !== selectedSettlementType) {
        if (selectedSettlementType === 'ted_tef' && accountCetipInput instanceof HTMLInputElement) {
          accountCetipInput.value = '';
        }
        if (isCetip && bankAccountSelect instanceof HTMLSelectElement) {
          bankAccountSelect.value = '';
        }
      }

      if (isCetip && typeof window.loadPassiveCetipInterfaces === 'function') {
        const fundSelect = document.getElementById('ticket_passive_quotum_fund_code');
        window.loadPassiveCetipInterfaces(
          fundSelect?.value,
          fundSelect?.dataset?.fundCetipInterfacesPath,
          { resetToFundAccount: false }
        );
      }

      previousSettlementType = selectedSettlementType;
    };

    togglePassiveSettlementFields();

    operationTypeRadios.forEach((radio) => {
      radio.addEventListener('change', togglePassiveSettlementFields);
    });

    settlementTypeRadios.forEach((radio) => {
      radio.addEventListener('change', togglePassiveSettlementFields);
    });
  };

  $(document).ready(function() {
    setupPassiveBankAccountToggle('passive_quotum');
  });

  if (!nodesPassive.length) return;

  const searchBankAccounts = (fundId, url, field, filters = null) => {
    if (!!filters) {
      url = `${url}?${filters}`;
    }

    $(`${field}`).find('option').remove().end();

    $.ajax({
      url: url,
      type: 'GET',
      data: { fund_id: fundId, is_active: true },
      success: function(response) {
        if (Array.isArray(response)) {
          for (let x = 0; x < response.length; x++) {
            const text = response[x].text;
            const id = response[x].id;
            $(`${field}`).append($('<option />').val(id).text(text));
          }
          $(`${field}`).trigger('change');
        } else {
          console.error('A resposta não é um array.');
        }
      }
    });
  };

  const parsePassiveFundText = (text, field) => {
    if (!text) return '';

    const patterns = {
      nome: /Fundo:\s*(.+?)\s*\|\s*Documento:/i,
      documento: /Documento:\s*([^|]+?)\s*\|\s*Administrador:/i,
      administrador: /Administrador:\s*([^|]+?)\s*\|\s*Conta Cetip:/i,
      conta_cetip: /Conta Cetip:\s*(.+)$/i
    };

    const match = text.match(patterns[field]);
    return match ? match[1].trim() : '';
  };

  const setPassiveFundFieldValue = (selector, value) => {
    if (!selector) return;

    const $field = $(selector);
    if (!$field.length) return;

    const normalized = value == null ? '' : String(value).trim();
    const wasDisabled = $field.prop('disabled');

    if (wasDisabled) {
      $field.prop('disabled', false);
    }

    $field.val(normalized).trigger('change');

    if (wasDisabled) {
      $field.prop('disabled', true);
    }
  };

  const resolveFundFieldValue = (data, ...keys) => {
    if (!data) return '';

    for (const key of keys) {
      const value = data[key];
      if (value != null && String(value).trim() !== '') {
        return String(value).trim();
      }
    }

    return '';
  };

  const clearPassiveFundDetailFieldsForElement = (element) => {
    const {
      quotationDate,
      settlementDate,
      fundAssetCodeCetip,
      fundAccountCetip,
      fundBank,
      fundAgency,
      fundAccount,
      condominium,
      fundNameField,
      fundDocumentField,
      fundAdministratorField
    } = element.dataset;

    [
      quotationDate,
      settlementDate,
      fundAssetCodeCetip,
      fundAccountCetip,
      fundBank,
      fundAgency,
      fundAccount,
      condominium,
      fundNameField,
      fundDocumentField,
      fundAdministratorField
    ]
      .filter(Boolean)
      .forEach((selector) => setPassiveFundFieldValue(selector, ''));

    const formPrefixMatch = (element.name || '').match(/^ticket_passive_(?:inr|quotum)/);
    if (formPrefixMatch) {
      const prefix = formPrefixMatch[1];
      setPassiveFundFieldValue(`[name="${prefix}[fund_name]"]`, '');
      setPassiveFundFieldValue(`[name="${prefix}[fund_document_number]"]`, '');
      setPassiveFundFieldValue(`[name="${prefix}[invested_fund_administrator]"]`, '');
    }

    const baseId = (element.id || '').replace(/_fund_code$/, '');
    if (baseId) {
      setPassiveFundFieldValue(`#${baseId}_fund_name`, '');
      setPassiveFundFieldValue(`#${baseId}_fund_document_number`, '');
      setPassiveFundFieldValue(`#${baseId}_invested_fund_administrator`, '');
    }
  };

  const destroyPassiveFundSelect = ($element) => {
    const pendingRequest = $element.data('passiveFundAjaxRequest');
    if (pendingRequest && pendingRequest.abort) {
      pendingRequest.abort();
    }

    if ($element.hasClass('select2-hidden-accessible')) {
      $element.select2('close');
      $element.select2('destroy');
    }
  };

  const INVALID_PASSIVE_FUND_SELECTION_VALUES = new Set(['yes', 'no']);

  const isValidPassiveFundSelectionValue = (value) => {
    const normalized = (value || '').toString().trim().toLowerCase();
    return normalized.length > 0 && !INVALID_PASSIVE_FUND_SELECTION_VALUES.has(normalized);
  };

  const passiveFundSelectionLabel = (fundCode, fundName, fundDocument, fundAdministrator, fundAccountCetip) => (
    [
      fundCode ? `Código: ${fundCode}` : null,
      fundName ? `Fundo: ${fundName}` : null,
      fundDocument ? `Documento: ${fundDocument}` : null,
      fundAdministrator ? `Administrador: ${fundAdministrator}` : null,
      fundAccountCetip ? `Conta Cetip: ${fundAccountCetip}` : null
    ].filter(Boolean).join(' | ')
  );

  const readPreservedFundSelection = (element) => {
    const $element = $(element);
    const initialFundCode = (element.dataset.initialFundCode || '').trim();
    let value = ($element.val() || '').toString().trim();
    let selectedText = ($element.find('option:selected').text() || '').trim();

    if (!isValidPassiveFundSelectionValue(value) && isValidPassiveFundSelectionValue(initialFundCode)) {
      value = initialFundCode;
      const matchedOption = $element.find('option').filter((_, option) => (
        ($(option).val() || '').toString().trim() === initialFundCode
      )).first();

      if (matchedOption.length) {
        selectedText = (matchedOption.text() || '').trim();
      }
    }

    if (isValidPassiveFundSelectionValue(value)) {
      return { value, text: selectedText || value };
    }

    const baseId = (element.id || '').replace(/_fund_code$/, '');
    if (!baseId) return null;

    const fundCode = initialFundCode;
    const fundName = ($(`#${baseId}_fund_name`).val() || '').trim();
    const fundDocument = ($(`#${baseId}_fund_document_number`).val() || '').trim();
    if (!isValidPassiveFundSelectionValue(fundCode) && !fundName && !fundDocument) return null;

    const fundAdministrator = ($(`#${baseId}_invested_fund_administrator`).val() || '').trim();
    const fundAccountCetip = ($(`#${baseId}_fund_account_cetip`).val() || '').trim();
    const resolvedValue = isValidPassiveFundSelectionValue(fundCode) ? fundCode : null;

    if (!resolvedValue) return null;

    const text = passiveFundSelectionLabel(
      resolvedValue,
      fundName,
      fundDocument,
      fundAdministrator,
      fundAccountCetip
    );

    return { value: resolvedValue, text: text || resolvedValue };
  };

  const restorePreservedFundSelection = ($element, preserved) => {
    if (!preserved?.value) return;

    const text = preserved.text || preserved.value;
    $element.append(new Option(text, preserved.value, true, true));
  };

  let passiveCetipAccounts = [];
  let passiveCetipRequestId = 0;
  let passiveFundCetipDefault = ($('#ticket_passive_quotum_fund_account_cetip').val() || '').toString().trim();

  const selectHasValue = ($select, value) => (
    !!value && $select.find('option').filter(function() { return this.value === value; }).length > 0
  );

  const shouldLoadPassiveCetipInterfaces = () => selectedSettlementType() === 'cetip';

  const fillFundCetipSelect = (accounts, options = {}) => {
    const $select = $('#ticket_passive_quotum_fund_account_cetip');
    if (!$select.length) return;

    const current = ($select.val() || '').toString().trim();
    const fundAccount = options.clear ? '' : passiveFundCetipDefault;
    const preferred = options.clear
      ? ''
      : (options.resetToFundAccount ? (fundAccount || current) : (current || fundAccount));
    const wasDisabled = $select.prop('disabled');

    $select.empty();
    $select.append(new Option('Selecione a conta CETIP', ''));
    (accounts || []).forEach((account) => {
      const value = (account.value || '').toString().trim();
      if (!value) return;
      $select.append(new Option(value, value, false, value === preferred));
    });
    if (fundAccount && !selectHasValue($select, fundAccount)) {
      $select.append(new Option(fundAccount, fundAccount, false, fundAccount === preferred));
    }
    $select.val(preferred || '');
    const editable = String($select.data('cetipEditable')) === 'true';
    if (editable) {
      $select.prop('disabled', false).prop('readonly', false);
      $select.removeAttr('disabled').removeAttr('readonly').removeClass('bg-light');
    } else {
      $select.prop('disabled', wasDisabled);
    }
    if (($select.val() || '').toString().trim() !== current) $select.trigger('change');
  };

  const loadPassiveCetipInterfaces = (fundCode, path, options = {}) => {
    if (!path || !shouldLoadPassiveCetipInterfaces()) return;

    const requestId = ++passiveCetipRequestId;
    const code = (fundCode || '').toString().trim();
    if (!code) {
      passiveFundCetipDefault = '';
      fillFundCetipSelect([], { clear: true });
      return;
    }

    $.get(path, { fund_code: code }).done((response) => {
      if (requestId !== passiveCetipRequestId) return;
      passiveCetipAccounts = (response && response.accounts) || [];
      fillFundCetipSelect(passiveCetipAccounts, options);
    });
  };

  window.loadPassiveCetipInterfaces = loadPassiveCetipInterfaces;

  const setupPassiveFundSelectElement = (element) => {
    const $element = $(element);
    const preservedSelection = readPreservedFundSelection(element);
    const fundsPath = element.dataset.fundsPath;
    const bankAccountsPath = element.dataset.fundAccountsPath;
    const fundBankAccountField = element.dataset.fundAccountField;
    const accountType = element.dataset.accountType;
    const quotationDate = element.dataset.quotationDate;
    const settlementDate = element.dataset.settlementDate;
    const fundAssetCodeCetip = element.dataset.fundAssetCodeCetip;
    const cetipInterfacesPath = element.dataset.fundCetipInterfacesPath;
    const fundBank = element.dataset.fundBank;
    const fundAgency = element.dataset.fundAgency;
    const fundAccount = element.dataset.fundAccount;
    const condominium = element.dataset.condominiumCd;
    const ticketKind = element.dataset.ticketKind;
    // forceSettlementType evita filtro de conta CETIP (ted_tef / no_financial).
    const forcedOperationType = element.dataset.forceOperationType;
    const forcedSettlementType = element.dataset.forceSettlementType;
    const fundNameField = element.dataset.fundNameField;
    const fundDocumentField = element.dataset.fundDocumentField;
    const fundAdministratorField = element.dataset.fundAdministratorField;
    const passiveModality = selectedPassiveModality();
    const canSearchFunds = fundSelectEditable(element);

    destroyPassiveFundSelect($element);
    $element.empty();
    $element.data('passiveModality', passiveModality);
    if (canSearchFunds) {
      restorePreservedFundSelection($element, preservedSelection);
      $element.prop('disabled', false);
    } else {
      $element.prop('disabled', true);
    }

    const fillPassiveFundDetailFields = (selectElement, data) => {
      if (!data) return;

      const text = data.text || '';
      const fundName =
        data.passive_fund_nome ||
        data.passiveFundNome ||
        data.fund_name ||
        parsePassiveFundText(text, 'nome');
      const fundDocument =
        data.fund_document_number ||
        data.document ||
        parsePassiveFundText(text, 'documento');
      const fundAdministrator =
        data.passive_fund_administrador ||
        data.passiveFundAdministrador ||
        data.invested_fund_administrator ||
        data.administrator ||
        data.administrador ||
        parsePassiveFundText(text, 'administrador');

      setPassiveFundFieldValue(fundNameField, fundName);
      setPassiveFundFieldValue(fundDocumentField, fundDocument);
      setPassiveFundFieldValue(fundAdministratorField, fundAdministrator);

      const formPrefixMatch = (selectElement.name || '').match(/^ticket_passive_(?:inr|quotum)/);
      if (formPrefixMatch) {
        const prefix = formPrefixMatch[1];
        setPassiveFundFieldValue(`[name="${prefix}[fund_name]"]`, fundName);
        setPassiveFundFieldValue(`[name="${prefix}[fund_document_number]"]`, fundDocument);
        setPassiveFundFieldValue(`[name="${prefix}[invested_fund_administrator]"]`, fundAdministrator);
      }

      const baseId = (selectElement.id || '').replace(/_fund_code$/, '');
      if (baseId) {
        setPassiveFundFieldValue(`#${baseId}_fund_name`, fundName);
        setPassiveFundFieldValue(`#${baseId}_fund_document_number`, fundDocument);
        setPassiveFundFieldValue(`#${baseId}_invested_fund_administrator`, fundAdministrator);
      }
    };

    const resolvePassiveFundData = (selectElement, event) => {
      if (event?.params?.data) return event.params.data;
      if (event?.params?.args?.data) return event.params.args.data;

      const selected = $(selectElement).select2('data');
      return selected && selected.length ? selected[0] : null;
    };

    const applyPassiveFundSelection = (event) => {
      const data = resolvePassiveFundData(event.currentTarget, event);
      if (!data) return;

      const operationType = forcedOperationType || operationTypeForFundSearch(element);

      if (operationType == 'application') {
        setPassiveFundFieldValue(quotationDate, data.quotation_date_application);
        setPassiveFundFieldValue(settlementDate, data.settlement_date_application);
      } else {
        setPassiveFundFieldValue(quotationDate, data.quotation_date_redeem);
        setPassiveFundFieldValue(settlementDate, data.settlement_date_redeem);
      }

      fillPassiveFundDetailFields(event.currentTarget, data);

      setPassiveFundFieldValue(
        fundAssetCodeCetip,
        resolveFundFieldValue(data, 'fund_asset_code_cetip', 'fundAssetCodeCetip')
      );
      passiveFundCetipDefault = (
        resolveFundFieldValue(data, 'fund_account_cetip', 'fundAccountCetip') ||
        parsePassiveFundText(data.text || '', 'conta_cetip') ||
        ''
      ).toString().trim();
      setPassiveFundFieldValue(fundBank, data.bank);
      setPassiveFundFieldValue(fundAgency, data.agency);
      setPassiveFundFieldValue(fundAccount, data.account);
      setPassiveFundFieldValue(condominium, data.is_cff);
      if (shouldLoadPassiveCetipInterfaces()) {
        loadPassiveCetipInterfaces(data.id || data.code, cetipInterfacesPath, { resetToFundAccount: true });
      } else {
        fillFundCetipSelect(
          passiveFundCetipDefault ? [{ value: passiveFundCetipDefault }] : [],
          { resetToFundAccount: true }
        );
      }
    };

    const secondaryFundSelect = Boolean(element.dataset.shareholderDocumentField);
    const placeholder = secondaryFundSelect
      ? 'Buscar fundo fechado com posição do cotista vendedor...'
      : passiveModality === 'qi_tech'
        ? 'Buscar fundo (Gestão QI TECH)...'
        : 'Buscar fundo (Gestão)...';

    $element.select2({
      placeholder: placeholder,
      allowClear: true,
      tags: false,
      selectOnClose: false,
      ajax: {
        url: fundsPath,
        dataType: 'json',
        cache: false,
        delay: 200,
        transport: (params, success, failure) => {
          const operationType = forcedOperationType || operationTypeForFundSearch(element);
          const isRedeem = operationType === 'redeem' || operationType === 'full_redeem';
          const sellerDocument = (shareholderDocumentForFundSearch(element) || '').toString().replace(/[^0-9A-Za-z]/g, '');
          const requiresSellerDocument = Boolean(element.dataset.shareholderDocumentField) || isRedeem;

          if (element.dataset.shareholderDocumentField && requiresSellerDocument && !sellerDocument) {
            success({ results: [] });
            return;
          }

          const pendingRequest = $element.data('passiveFundAjaxRequest');
          if (pendingRequest && pendingRequest.abort) {
            pendingRequest.abort();
          }

          const request = $.ajax(params);
          $element.data('passiveFundAjaxRequest', request);
          request.then(success).fail(failure);
          return request;
        },
        data: (params) => {
          const modality = selectedPassiveModality();
          const payload = {
            q: params.term,
            select_2_extra: accountType,
            operationType: forcedOperationType || operationTypeForFundSearch(element),
            settlementType: forcedSettlementType || selectedSettlementType(),
            document: shareholderDocumentForFundSearch(element),
            ticket_kind: ticketKind || 'passive_quotum',
            modality: modality
          };

          if (modality === 'secondary_market') {
            payload.position_date = document.querySelector('#ticket_passive_quotum_operation_date_secondary')?.value || '';
          }

          return payload;
        }
      }
    });

    if (preservedSelection?.value) {
      $element.trigger('change');
      loadPassiveCetipInterfaces(preservedSelection.value, cetipInterfacesPath);
    }

    $element.off('select2:select.passiveFund select2:open.passiveFund change.passiveFund');
    $element.on('select2:select.passiveFund', applyPassiveFundSelection);

    $element.on('select2:open.passiveFund', () => {
      if ($element.data('passiveModality') !== selectedPassiveModality()) {
        resetPassiveFundSelectForModalityChange();
      }
    });

    $element.on('change.passiveFund', function() {
      const selectedId = $(this).val();

      if (!selectedId) {
        clearPassiveFundDetailFieldsForElement(element);
        loadPassiveCetipInterfaces('', cetipInterfacesPath, { clear: true });
        return;
      }

      if (selectedId) {
        const selectedData = $(this).select2('data')[0];
        const fundIdValue = selectedData.fund_id;
        if (fundIdValue) {
          searchBankAccounts(fundIdValue, bankAccountsPath, fundBankAccountField, null);
        }
      }
    });
  };

  const resetPassiveFundSelectForModalityChange = () => {
    nodesPassive.each((_index, element) => {
      clearPassiveFundDetailFieldsForElement(element);
      setupPassiveFundSelectElement(element);
    });
  };

  nodesPassive.each((_index, element) => {
    setupPassiveFundSelectElement(element);
  });

  const updateNewInvestedFundVisibility = () => {
    const modality = selectedPassiveModality();
    const $newFundWrapper = $('#ticket_passive_quotum_new_invested_fund_wrapper');
    const $newFundCheckbox = $('#ticket_passive_quotum_new_invested_fund');
    const operationType = selectedOperationType();
    const showNewFund = modality !== 'qi_tech' && operationType === 'application';

    if (showNewFund) {
      $newFundWrapper.show();
    } else {
      $newFundWrapper.hide();
      $newFundCheckbox.prop('checked', false).trigger('change');
    }
  };

  const togglePassiveModalityUi = () => {
    updateNewInvestedFundVisibility();
    resetPassiveFundSelectForModalityChange();
  };

  const initPassiveModalityUi = () => {
    updateNewInvestedFundVisibility();
  };

  $(document).on('change', '.JS-passive-modality-toggle', togglePassiveModalityUi);
  initPassiveModalityUi();

  $(document).on(
    'change',
    '.JS-passive-secondary-market-fields input[name="ticket_passive_quotum[operation_type]"]',
    () => {
      nodesPassive.each((_index, element) => {
        if (!element.dataset.shareholderDocumentField) return;

        clearPassiveFundDetailFieldsForElement(element);
        setupPassiveFundSelectElement(element);
      });
    }
  );

  $(document).on('input', '#ticket_passive_quotum_shareholder_fund_document_number', () => {
    nodesPassive.each((_index, element) => {
      if (!element.dataset.shareholderDocumentField) return;
      if (!$(element).val()) return;

      $(element).val(null).trigger('change');
      element.dataset.initialFundCode = '';
    });
  });
});
